import React, { FC, memo } from 'react'
import cn, { Argument as ClassName } from 'classnames'
import styled from 'styled-components'

import { WidgetLayout } from '../../../lib/widget-layout'
import Text from '../../../ui/Text'
import { useChargePointGetPartnerQuery } from '../../../common/redux/api/web-api'
import PartnerInfoCard from '../support/PartnerInfoCard'
import LinkButton from '../support/LinkButton'
import useText from '../../hooks/useText'

const SPartnerDetailsMessage = styled.label`
    font-size: 16px;
    line-height: 24px;
    display: block;
    margin-bottom: 20px;
`

export type Props = {
    chargePointId: string
    className?: ClassName
    style?: React.CSSProperties
}

export const ChargePointPartnerInfoWidget: FC<Props> = memo(({ style, className, chargePointId }) => {
    const text = useText()
    const { data: partner, isLoading } = useChargePointGetPartnerQuery({ chargePointId })
    return (
        <WidgetLayout
            className={cn(className)}
            style={style}
            data-testid="support"
            title={text('lblSupportInformation')}
        >
            {isLoading ? (
                <div className="shimmer-container shimmer-small" data-testid="loader"></div>
            ) : (
                <>
                    {partner ? (
                        <div className="margin-bottom-small">
                            <SPartnerDetailsMessage data-testid="partner-details-message">
                                {text('msgContactTheFollowingProvider')}
                            </SPartnerDetailsMessage>
                            <PartnerInfoCard name={partner?.name} email={partner?.email} phone={partner?.phone} />
                        </div>
                    ) : null}

                    <Text code={'lblFaq'} />
                    <LinkButton
                        dataTestId="link-charge-amps-support-page"
                        titleCode="lblChargeAmpsSupportPage"
                        href={`https://www.chargeamps.com/${text('linkSupport')}`}
                    />
                    <LinkButton
                        dataTestId="link-charge-amps-help-center-page"
                        titleCode="lblChargeAmpsHelpCenter"
                        href={text('linkHelpCenter')}
                    />
                </>
            )}
        </WidgetLayout>
    )
})
